import helper from 'util/helpers'
import eventBus from '@/event_bus'
import eventType from '@/components/operation/enums/eventType'
import messageUtil from 'util/messages'
import moment from 'moment'

const getDefaultState = () => {
  return {
    messageSize: 20,
    displayingChatRoomId: -1,
    displayingChatRoomStatus: 'ACTIVE',
    tabChatRooms: [],
    assignChatRooms: [],
    activeChatRooms: [],
    completedChatRooms: [],
    summaryChatRooms: [],
    allChatRooms: [],
    transferredChatRooms: [],
    selectedRoomStatus: ['ASSIGN', 'ACTIVE', 'WAITING', 'SUMMARY_WAITING', 'COMPLETED', 'TAKE_OVER_ROOM'],
    selectedTabStatus: 'ACTIVE', // 현재 선택중인 탭
    markedChatRoom: '',
    inputAreaHeightLevel: 0,
    tagList: [],
    alarmedChatRoomId: '',
    isSearchAllChatRoomMode: false,
    lastMessages: [],
    waitCount: 0
  }
}
const state = getDefaultState()

const getters = {
  messageSize: (state) => {
    return state.messageSize
  },
  displayingChatRoomId: (state) => {
    return state.displayingChatRoomId
  },
  displayingChatRoomStatus: (state) => {
    return state.displayingChatRoomStatus
  },
  isChatRoomInTabChatRooms: (state) => {
    return (chatRoomId) => {
      return helper.isObjectValid(helper.findByChatRoomId(state.tabChatRooms, chatRoomId))
    }
  },
  chatRoomTabList: (state) => {
    return state.tabChatRooms
  },
  selectedRoomStatus: (state) => {
    return state.selectedRoomStatus
  },
  selectedTabStatus: (state) => {
    return state.selectedTabStatus
  },
  assignChatRoomList: (state) => {
    return state.assignChatRooms.sort((left, right) => right.chatRoomId - left.chatRoomId)
  },
  activeChatRoomList: (state) => {
    return state.activeChatRooms.sort((left, right) => right.chatRoomId - left.chatRoomId)
  },
  completeChatRoomList: (state) => {
    return state.completedChatRooms.sort((left, right) => right.chatRoomId - left.chatRoomId)
  },
  summaryChatRoomList: (state) => {
    return state.summaryChatRooms.sort((left, right) => right.chatRoomId - left.chatRoomId)
  },
  transferredChatRoomList: (state) => {
    return state.transferredChatRooms.sort((left, right) => right.chatRoomId - left.chatRoomId)
  },
  allChatRoomList: (state) => {
    return state.allChatRooms.sort((left, right) => right.chatRoomId - left.chatRoomId)
  },
  // operation_left 에서 정렬을 생성순 -> 상담 연결순으로 변경
  assignChatRoomListOrderByCreateDate: (state) => {
    return state.assignChatRooms.sort((left, right) => right.createDate - left.createDate)
  },
  activeChatRoomListOrderByCreateDate: (state) => {
    return state.activeChatRooms.sort((left, right) => right.createDate - left.createDate)
  },
  completeChatRoomListOrderByCreateDate: (state) => {
    // return state.completedChatRooms.sort((left, right) => right.createDate - left.createDate)
    return state.completedChatRooms.sort((left, right) => left.completeTime === undefined ? -1 : right.completeTime - left.completeTime)
  },
  summaryChatRoomListOrderByCreateDate: (state) => {
    // return state.summaryChatRooms.sort((left, right) => right.createDate - left.createDate)
    return state.summaryChatRooms.sort((left, right) => left.summaryTime === undefined ? -1 : right.summaryTime - left.summaryTime)
  },
  transferredChatRoomListOrderByCreateDate: (state) => {
    return state.transferredChatRooms.sort((left, right) => right.createDate - left.createDate)
  },
  allChatRoomListOrderByCreateDate: (state) => {
    return state.allChatRooms.sort((left, right) => right.createDate - left.createDate)
  },
  markedChatRoom: (state) => {
    return state.markedChatRoom
  },
  inputAreaHeightLevel: (state) => {
    return state.inputAreaHeightLevel
  },
  tagList: (state) => {
    return state.tagList
  },
  alarmedChatRoomId: (state) => {
    return state.alarmedChatRoomId
  },
  isSearchAllChatRoomMode: (state) => {
    return state.isSearchAllChatRoomMode
  },
  getLastMessages (state) {
    return state.lastMessages
  },
  getWaitCount: (state) => {
    return state.waitCount
  }
}

const actions = {
  addTabAssignChatRoom (context, chatRoom) {
    const newRoom = Object.assign({}, chatRoom)
    newRoom.status = 'ASSIGN'
    context.commit('addTabChatRoom', newRoom)
  },
  addTabActiveChatRoom (context, chatRoom) {
    const newRoom = Object.assign({}, chatRoom)
    newRoom.status = 'ACTIVE'
    context.commit('addTabChatRoom', newRoom)
  },
  addTabSummaryWaitingChatRoom (context, chatRoom) {
    const newRoom = Object.assign({}, chatRoom)
    newRoom.status = 'SUMMARY_WAITING'
    context.commit('addTabChatRoom', newRoom)
  },
  addTabCompletedChatRoom (context, chatRoom) {
    const newRoom = Object.assign({}, chatRoom)
    newRoom.status = 'COMPLETED'
    context.commit('addTabChatRoom', newRoom)
  },
  addTabTransferChatRoom (context, chatRoom) {
    const newRoom = Object.assign({}, chatRoom)
    newRoom.status = 'TRANSFER'
    context.commit('addTabChatRoom', newRoom)
  },
  addTabAllChatRoom (context, chatRoom) {
    const newRoom = Object.assign({}, chatRoom)
    newRoom.status = 'ALL'
    newRoom.secondStatus = chatRoom.status
    context.commit('addTabChatRoom', newRoom)
  }
}

const mutations = {
  changeSelectedStatus (state, statuses) {
    state.selectedRoomStatus = statuses
  },
  changeSelectedTabStatus (state, statuses) {
    state.selectedTabStatus = statuses
  },
  changeDisplayingChatRoomId (state, chatRoomId) {
    state.displayingChatRoomId = chatRoomId
  },
  changeDisplayingChatRoomStatus (state, status) {
    state.displayingChatRoomStatus = status
  },
  setLastMessages (state, data) {
    try {
      if (data.moduleChannelName === 'MAIL') {
        state.lastMessages[data.chatRoomId] = {
          message: '',
          date: helper.printTimeStampMMDDFromDateTime(data.createDate),
          timeDiff: moment(helper.printTimeStampYYYYMMDDHHmmFromDateTime(data.createDate)).fromNow(),
          onlyTime: helper.printTimeStampHHmmFromDateTime(data.createDate)
        }
      } else {
        let showMessage = ''
        let contentType = JSON.parse(data.lastChatMessage)
        switch (data.messageType || 'TEXT') {
          case 'TEXT':
          case 'START':
          case 'END':
          case 'ASSIGN':
          case 'BROWSER_EXIT':
            showMessage += helper.longTextLengthAdjust(contentType.text, 15)
            break
          case 'PHOTO':
            showMessage += '<<画像>>'
            break
          case 'VIDEO':
            showMessage += '<<映画>>'
            break
          case 'COMBINATION':
            showMessage += helper.longTextLengthAdjust(contentType.text, 15)
            break
        }
        let brandBanWordInfo = messageUtil.getBanWords().filter(info => info.brandId === data.brandId)
        state.lastMessages[data.chatRoomId] = {
          message: brandBanWordInfo[0] ? messageUtil.replaceBanWordToStar(brandBanWordInfo[0].banWords, showMessage) : showMessage,
          date: helper.printTimeStampMMDDFromDateTime(data.lastChatMessageTime),
          timeDiff: moment(helper.printTimeStampYYYYMMDDHHmmFromDateTime(data.lastChatMessageTime)).fromNow(),
          onlyTime: helper.printTimeStampHHmmFromDateTime(data.lastChatMessageTime)
        }
      }
    } catch (e) {
      console.log(e)
    }
  },
  setNewMessageFlagToAssignChatRoomList (state, chatRoomId) {
    const chatRoom = helper.findByChatRoomId(state.assignChatRooms, chatRoomId)
    if (helper.isObjectValid(chatRoom)) {
      chatRoom.newMessageFlag = true
    }
  },
  setNewMessageFlagToActiveChatRoomList (state, chatRoomId) {
    const chatRoom = helper.findByChatRoomId(state.activeChatRooms, chatRoomId)
    if (helper.isObjectValid(chatRoom)) {
      chatRoom.newMessageFlag = true
    }
  },
  setNewMessageFlagToTransferChatRoomList (state, chatRoomId) {
    const chatRoom = helper.findByChatRoomId(state.transferredChatRooms, chatRoomId)
    if (helper.isObjectValid(chatRoom)) {
      chatRoom.newMessageFlag = true
    }
  },
  deleteNewMessageFlagToAssignChatRoomList (state, chatRoomId) {
    const chatRoom = helper.findByChatRoomId(state.assignChatRooms, chatRoomId)
    if (helper.isObjectValid(chatRoom)) {
      chatRoom.newMessageFlag = false
    }
  },
  deleteNewMessageFlagToActiveChatRoomList (state, chatRoomId) {
    const chatRoom = helper.findByChatRoomId(state.activeChatRooms, chatRoomId)
    if (helper.isObjectValid(chatRoom)) {
      chatRoom.newMessageFlag = false
    }
  },
  deleteNewMessageFlagToTransferChatRoomList (state, chatRoomId) {
    const chatRoom = helper.findByChatRoomId(state.transferredChatRooms, chatRoomId)
    if (helper.isObjectValid(chatRoom)) {
      chatRoom.newMessageFlag = false
    }
  },
  setNewMessageFlagToTabChatRoomList (state, chatRoomId) {
    const chatRoom = helper.findByChatRoomId(state.tabChatRooms, chatRoomId)
    if (helper.isObjectValid(chatRoom) && chatRoom.status !== 'ALL') {
      chatRoom.newMessageFlag = true
    }
  },
  deleteNewMessageFlagToTabChatRoomList (state, chatRoomId) {
    const chatRoom = helper.findByChatRoomId(state.tabChatRooms, chatRoomId)
    if (helper.isObjectValid(chatRoom)) {
      chatRoom.newMessageFlag = false
    }
  },
  addTabChatRoom (state, chatRoom) {
    const findChatRoom = helper.findByChatRoomId(state.tabChatRooms, chatRoom.chatRoomId)
    if (findChatRoom !== undefined && findChatRoom.status !== chatRoom.status) {
      state.tabChatRooms.splice(state.tabChatRooms.indexOf(findChatRoom), 1)
      state.tabChatRooms.push(chatRoom)
    } else if (!helper.isObjectValid(findChatRoom)) {
      state.tabChatRooms.push(chatRoom)
    }
    state.displayingChatRoomId = chatRoom.chatRoomId
  },
  addChatRoomOrderList (state, data) {
    const findChatRoom = helper.findByChatRoomId(state.tabChatRooms, data.chatRoomId)
    if (!findChatRoom.orderList) {
      findChatRoom.orderList = []
    }
    if (findChatRoom.orderList.indexOf(data.orderId) < 0) {
      findChatRoom.orderList.unshift(data.orderId)
    }
    const newRoom = Object.assign({}, findChatRoom)
    if (findChatRoom !== undefined) {
      state.tabChatRooms.splice(state.tabChatRooms.indexOf(findChatRoom), 1)
      state.tabChatRooms.push(newRoom)
    }
  },
  changeChatRoomOrderList (state, data) {
    let findChatRoom = helper.findByChatRoomId(state.tabChatRooms, data.chatRoomId)
    findChatRoom.orderList = data.newOrderList

    const newRoom = Object.assign({}, findChatRoom)
    if (findChatRoom !== undefined) {
      state.tabChatRooms.splice(state.tabChatRooms.indexOf(findChatRoom), 1)
      state.tabChatRooms.push(newRoom)
    }
  },
  deleteChatRoomOrderList (state, data) {
    const findChatRoom = helper.findByChatRoomId(state.tabChatRooms, data.chatRoomId)
    if (!findChatRoom.orderList) {
      return
    }

    if (findChatRoom.orderList.indexOf(data.orderId) > -1) {
      const idx = findChatRoom.orderList.indexOf(data.orderId)
      findChatRoom.orderList.splice(idx, 1)
    }
    const newRoom = Object.assign({}, findChatRoom)
    if (findChatRoom !== undefined) {
      state.tabChatRooms.splice(state.tabChatRooms.indexOf(findChatRoom), 1)
      state.tabChatRooms.push(newRoom)
    }
  },
  deleteTabChatRoom (state, chatRoom) {
    const tab = helper.findByChatRoomId(state.tabChatRooms, chatRoom.chatRoomId)
    if (!helper.isObjectValid(tab)) {
      return
    }
    state.tabChatRooms.splice(state.tabChatRooms.indexOf(tab), 1)
    if (state.tabChatRooms.length < 1) {
      state.markedChatRoom = undefined
      state.displayingChatRoomId = -1
    }
    if (tab.chatRoomId === state.displayingChatRoomId) {
      state.displayingChatRoomId = -1
      // 마지막 탭 세팅
      const last = helper.getLastItem(state.tabChatRooms)
      if (helper.isObjectValid(last)) {
        eventBus.$emit('chat-room-tab-open', last.chatRoomId)
        eventBus.$emit(eventType.OPEN_CUSTOMER_INFO_TAP)
      }
    }
  },
  addAssignChatRoom (state, chatRoom) {
    if (helper.findByChatRoomId(state.assignChatRooms, chatRoom.chatRoomId) === undefined) {
      const newStatusRoom = Object.assign({}, chatRoom)
      newStatusRoom.status = 'ASSIGN'
      state.assignChatRooms.push(newStatusRoom)
    }
  },
  removeAssignChatRoom (state, chatRoom) {
    const findChatRoom = helper.findByChatRoomId(state.assignChatRooms, chatRoom.chatRoomId)
    if (!helper.isObjectValid(findChatRoom)) {
      return
    }
    const chatRoomIndex = state.assignChatRooms.indexOf(findChatRoom)
    state.assignChatRooms.splice(chatRoomIndex, 1)
  },
  addToActiveChatRoomList (state, chatRoom) {
    let newRoom
    if (typeof chatRoom === 'string') {
      newRoom = Object.assign({}, JSON.parse(chatRoom))
    } else {
      newRoom = Object.assign({}, chatRoom)
    }
    if (helper.findByChatRoomId(state.activeChatRooms, newRoom.chatRoomId) === undefined) {
      newRoom.status = 'ACTIVE'
      state.activeChatRooms.push(newRoom)
    }
  },
  deleteToActiveChatRoomList (state, chatRoom) {
    const findChatRoom = helper.findByChatRoomId(state.activeChatRooms, chatRoom.chatRoomId)
    if (!helper.isObjectValid(findChatRoom)) {
      return
    }
    const chatRoomIndex = state.activeChatRooms.indexOf(findChatRoom)
    state.activeChatRooms.splice(chatRoomIndex, 1)
  },
  addSummaryChatRoom (state, chatRoom) {
    if (helper.findByChatRoomId(state.summaryChatRooms, chatRoom.chatRoomId) === undefined) {
      chatRoom.status = 'SUMMARY_WAITING'
      state.summaryChatRooms.push(chatRoom)
    }
  },
  removeSummaryChatRoom (state, chatRoom) {
    const findChatRoom = helper.findByChatRoomId(state.summaryChatRooms, chatRoom.chatRoomId)
    if (!helper.isObjectValid(findChatRoom)) {
      return
    }
    const chatRoomIndex = state.summaryChatRooms.indexOf(findChatRoom)
    state.summaryChatRooms.splice(chatRoomIndex, 1)
  },
  addCompletedChatRoom (state, chatRoom) {
    if (helper.findByChatRoomId(state.completedChatRooms, chatRoom.chatRoomId) === undefined) {
      chatRoom.status = 'COMPLETED'
      state.completedChatRooms.push(chatRoom)
    }
  },
  removeCompletedChatRoom (state, chatRoom) {
    const findChatRoom = helper.findByChatRoomId(state.completedChatRooms, chatRoom.chatRoomId)
    if (!helper.isObjectValid(findChatRoom)) {
      return
    }
    const chatRoomIndex = state.completedChatRooms.indexOf(findChatRoom)
    state.completedChatRooms.splice(chatRoomIndex, 1)
  },
  addTransferChatRooms (state, chatRoom) {
    if (helper.findByChatRoomId(state.transferredChatRooms, chatRoom.chatRoomId) === undefined) {
      const newStatusRoom = Object.assign({}, chatRoom)
      newStatusRoom.status = 'TRANSFER'
      state.transferredChatRooms.push(newStatusRoom)
    }
  },
  removeTransferChatRooms (state, chatRoom) {
    const findChatRoom = helper.findByChatRoomId(state.transferredChatRooms, chatRoom.chatRoomId)
    if (!helper.isObjectValid(findChatRoom)) {
      return
    }
    const chatRoomIndex = state.transferredChatRooms.indexOf(findChatRoom)
    state.transferredChatRooms.splice(chatRoomIndex, 1)
  },
  addAllChatRoom (state, chatRoom) {
    if (helper.findByChatRoomId(state.allChatRooms, chatRoom.chatRoomId) === undefined) {
      if (chatRoom.status === 'TAKE_OVER_ROOM') {
        chatRoom.status = 'TRANSFER'
      }
      if (chatRoom.isDelete) {
        delete chatRoom.isDelete
        state.allChatRooms.splice(state.allChatRooms.length - 1, 1)
      }
      state.allChatRooms.push(chatRoom)
    }
  },
  addAllChatRoomSendTransfer (state, chatRoom) {
    if (helper.findByChatRoomId(state.allChatRooms, chatRoom.chatRoomId) === undefined) {
      if (chatRoom.status === 'TAKE_OVER_ROOM') {
        chatRoom.status = 'TAKE_OVER_ROOM'
      }
      state.allChatRooms.push(chatRoom)
    }
  },
  removeAllChatRooms (state, chatRoom) {
    const findChatRoom = helper.findByChatRoomId(state.allChatRooms, chatRoom.chatRoomId)
    if (!helper.isObjectValid(findChatRoom)) {
      return
    }
    const chatRoomIndex = state.allChatRooms.indexOf(findChatRoom)
    state.allChatRooms.splice(chatRoomIndex, 1)
    delete state.lastMessages[chatRoom.chatRoomId]
  },
  clearAllChatRoom () {
    state.allChatRooms = []
  },
  CLEAR_CHAT (state) {
    Object.assign(state, getDefaultState())
  },
  markSelectedChatRoom (state, chatRoomId) {
    state.markedChatRoom = chatRoomId
  },
  inputAreaHeightResize (state, size) {
    state.inputAreaHeightLevel = size
  },
  clearTagList (state) {
    state.tagList = []
  },
  changeTagList (state, list) {
    state.tagList = list
  },
  setAlarmedChatRoomId (state, chatRoomId) {
    state.alarmedChatRoomId = chatRoomId
  },
  updateTabChatRoomList (state, chatRoom) {
    let updatedStatus = chatRoom.status
    // 챗룸탭에서는 이관 상태를 'TRANSFER'로 갖고 있기 때문에 변환
    if (updatedStatus === 'TAKE_OVER_ROOM') {
      updatedStatus = 'TRANSFER'
    }
    const chatRoomInTab = helper.findByChatRoomId(state.tabChatRooms, chatRoom.chatRoomId)
    if (helper.isObjectValid(chatRoomInTab)) {
      const chatRoomIndex = state.tabChatRooms.indexOf(chatRoomInTab)
      // 전체 탭에서 열은 방은 status가 'ALL'이고 secondStatus에 실제 상담방 상태가 들어가므로 각각 처리
      if (state.tabChatRooms[chatRoomIndex].status === 'ALL') {
        state.tabChatRooms[chatRoomIndex].secondStatus = updatedStatus
      } else {
        state.tabChatRooms[chatRoomIndex].status = updatedStatus
      }
      eventBus.$emit(eventType.UPDATE_TAB_CHAT_ROOM_LIST)
    }
  },
  checkSearchAllChatRoom (state, newStatus) {
    state.isSearchAllChatRoomMode = newStatus
  },
  setWaitCount: (state, statuses) => {
    state.waitCount = statuses
  }
}
export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/chat/index.js